export const REPAIR_REQUEST_ID_PREFIX = 'REQ';

export const SOURCE_OF_INFORMATION = [
  'Call Center',
  'Walk-in',
  'Website',
  'WhatsApp',
  'Drive',
];

// This is written if we want to use Drive as condition
export const DRIVE_CONSTANT = 'Drive';

export const END_CUSTOMER_CONSTANT = 'End Customer';

export const REQUESTS_FROM = [
  'Dealer',
  'End Customer'
];

export const MAX_DAYS_FOR_APPOINTMENT = 13;

export const REPAIR_SERVICE_ID = 'SID101';

export const MODE_OF_PAYMENT = [
  {
    label: 'Pay via link',
    value: 'Link'
  },
  {
    label: 'Cash',
    value: 'Cash'
  },
  {
    label: 'Pay Later',
    value: 'PayLater'
  },
];
